import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import PageTitle from '../components/PageTitle';

const AboutPage = () => {
  const values = [
    {
      number: "01",
      icon: "/Mask group (6).png",
      title: "Reliability",
      description: "On‑time deliveries, consistent quality, and responsive support you can count on.",
      positions: {
        mobile: { left: '1px', top: '25px' },
        desktop: { left: '31px', top: '-18px' }
      }
    },
    {
      number: "02", 
      icon: "/Mask group-1.png",
      title: "Innovation",
      description: "Turning legacy setups into smart, efficient, low‑waste manufacturing.",
      positions: {
        mobile: { left: '380px', top: '248px' },
        desktop: { left: '31px', top: '290px' }
      }
    },
    {
      number: "03",
      icon: "/Mask group-2.png",
      title: "Sustainability", 
      description: "Responsible materials, safer workplaces, and verifiable traceability.",
      positions: {
        mobile: { left: 'calc(100% - 380px)', top: 'calc(100% - 295px)' },
        desktop: { left: '31px', top: '-18px' }
      }
    },
    {
      number: "04",
      icon: "/Mask group-3.png",
      title: "Purpose",
      description: "Growth that creates meaningful opportunities for people and communities.",
      positions: {
        mobile: { left: '380px', top: 'calc(100% - 70px)' },
        desktop: { left: '32px', top: '290px' }
      }
    }
  ];

  // Toggle white text on scroll (black at top)
  useEffect(() => {
    const handleScroll = () => {
      const aboutNav = document.getElementById('about-nav');
      if (!aboutNav) return;
      if (window.scrollY > 0) {
        aboutNav.classList.add('scrolled');
      } else {
        aboutNav.classList.remove('scrolled');
      }
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="pt-20">
      <PageTitle title="About Us" />
      {/* Local navbar wrapper for About page */}
      <div id="about-nav" className="relative z-50">
        <Navbar />
      </div>

      {/* Hero Section - height reduced to 50vh */}
      <section className="relative min-h-[33vh] bg-light flex flex-col">
        <div className="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            {/* Book Icon - Made responsive */}
            <div className="mb-6 sm:mb-8">
              <svg 
                width="60" 
                height="60"
                className="sm:w-20 sm:h-20 mx-auto text-primary"
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="1.5"
              >
                <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
              </svg>
            </div>
            
            {/* Main Title - Made responsive */}
            <h1 
              className="heading-responsive font-bold text-dark leading-tight"
              style={{ fontFamily: 'Belleza, serif' }}
            >
              The HIK Story
            </h1>
          </div>
        </div>
      </section>

      {/* Timeline Section - Made responsive */}
      <section className="relative padding-responsive bg-white overflow-hidden">
        {/* Vector 7 Ribbon - Hidden on mobile, visible on desktop */}
        <div className="absolute inset-0 w-full h-full z-0 hidden md:block">
          <img 
            src="/Vector 7.png" 
            alt="Decorative ribbon"
            className="absolute left-20 top-4 w-[130%] h-[130%] sm:w-[130%] sm:h-[130%] md:w-[130%] md:h-[130%] lg:w-[130%] lg:h-[130%] object-contain pointer-events-none"
            style={{ 
              transform: 'translate(-220px, -3px)',
              transformOrigin: 'left top'
            }}
          />
        </div>

        <div className="container-responsive relative z-20">
          {/* Timeline */}
          <div className="relative space-y-16 sm:space-y-20">
            {/* Timeline Item 1 */}
            <div className="grid-responsive-2 items-center gap-8 lg:gap-12">
              <div className="lg:pr-6">
                <img
                  src="/WhatsApp Image 2025-10-21 at 15.23.20_c4c365b3.jpg"
                  alt="HIK Textiles Industrial Facility - 2018"
                  className="w-full h-64 sm:h-72 md:h-80 object-cover rounded-xl sm:rounded-2xl shadow-lg"
                />
              </div>
              <div>
                <div className="max-w-md lg:max-w-lg">
                  <h3 
                    className="mb-3 sm:mb-4 capitalize subheading-responsive"
                    style={{ fontFamily: 'Belleza, serif', fontWeight: 400, color: '#272525' }}
                  >
                    2018 -
                  </h3>
                  <p 
                    className="text-responsive-sm leading-relaxed font-normal"
                    style={{ fontFamily: 'Poppins, sans-serif', color: '#272525' }}
                  >
                    HIK started it's operations in 2018, fully adapting a public limited company, AL-Qaim Textile Limited. With humble beginning in textile industry and under experienced directors in International Trade, Weaving and Yarn Manufacturing.
                  </p>
                </div>
              </div>
            </div>

            {/* Timeline Item 2 */}
            <div className="flex flex-col lg:flex-row-reverse items-center mb-20">
              <div className="lg:w-1/2 lg:pl-12 mb-8 lg:mb-0 relative">
                <img
                  src="/WhatsApp Image 2025-10-21 at 15.23.22_fc235b46.jpg"
                  alt="Sustainability at HIK"
                  className="w-full h-80 object-cover rounded-2xl shadow-lg"
                />
              </div>
              <div className="lg:w-1/2 lg:pr-12">
                <div className="max-w-[420px]">
                  <h3 
                    className="mb-4 capitalize"
                    style={{ fontFamily: 'Belleza, serif', fontWeight: 400, fontSize: '40px', lineHeight: '52px', color: '#272525' }}
                  >
                    Sustainable With A Passion.
                  </h3>
                  <p 
                    className="text-[16px] leading-[150%] font-normal"
                    style={{ fontFamily: 'Poppins, sans-serif', color: '#272525' }}
                  >
                    Our quality and sustainability are backed by certifications in GRS, Oeko-Tex, and ISO 9001:2015.
                  </p>
                </div>
              </div>
            </div>

            {/* Timeline Item 3 */}
            <div className="flex flex-col lg:flex-row items-center mb-20">
              <div className="lg:w-1/2 lg:pr-12 mb-8 lg:mb-0">
                <img
                  src="/WhatsApp Image 2025-10-21 at 15.23.21_3e2ea836.jpg"
                  alt="Industrial factory interior - 2021"
                  className="w-full h-80 object-cover rounded-2xl shadow-lg"
                />
              </div>
              <div className="lg:w-1/2 lg:pl-12">
                <div className="max-w-[420px]">
                  <h3 
                    className="mb-4 capitalize"
                    style={{ fontFamily: 'Belleza, serif', fontWeight: 400, fontSize: '40px', lineHeight: '52px', color: '#272525' }}
                  >
                    Relentless And Resilient
                  </h3>
                  <p 
                    className="text-[16px] leading-[150%] font-normal"
                    style={{ fontFamily: 'Poppins, sans-serif', color: '#272525' }}
                  >
                    Against all odds, including the global COVID‑19 pandemic, HIK expanded operations, setting its second production facility.
                  </p>
                </div>
              </div>
            </div>

            {/* Timeline Item 4 */}
            <div className="flex flex-col lg:flex-row-reverse items-center mb-20">
              <div className="lg:w-1/2 lg:pl-12 mb-8 lg:mb-0">
                <img
  src="/WhatsApp Image 2025-10-19 at 13.05.22_01d8d9b3.jpg"
  alt="Spools of yarn on industrial rack - 2024"
  className="w-full h-80 object-cover rounded-2xl shadow-lg"
              />
              </div>
              <div className="lg:w-1/2 lg:pl-12">
                <div className="max-w-[420px]">
                  <h3 
                    className="mb-4 capitalize"
                    style={{ fontFamily: 'Belleza, serif', fontWeight: 400, fontSize: '40px', lineHeight: '52px', color: '#272525' }}
                  >
                    To grow is to share our growth
                  </h3>
                  <p 
                    className="text:[16px] leading-[150%] font-normal"
                    style={{ fontFamily: 'Poppins, sans-serif', color: '#272525' }}
                  >
                    and thus HIK diversified business with a purpose – to create economic opportunities for women in underserved communities.
                  </p>
                </div>
              </div>
            </div>

            
          </div>
        </div>
      </section>

      {/* Values Section - Mobile */}
      <section className="relative padding-responsive md:hidden overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: "url('/Rectangle 18.png')" }}
        />
        <div className="relative z-10">
          <div className="container-responsive">
            <div className="text-center mb-12 sm:mb-16">
              <p 
                className="uppercase tracking-widest text-responsive-xs text-dark mb-3 sm:mb-4"
                style={{ fontFamily: 'Poppins, sans-serif' }}
              >
                OUR VALUES
              </p>
              <h2 
                className="subheading-responsive text-dark leading-tight pb-4"
                style={{ fontFamily: 'Belleza, serif' }}
              >
                What We Stand For Every Day
              </h2>
            </div>

            <div className="grid grid-cols-1 gap-6 sm:gap-8 max-w-4xl mx-auto">
              {values.map((value, index) => (
                <div key={index} className="relative w-full px-4">
                  <div className="w-full max-w-[380px] mx-auto bg-white rounded-2xl shadow-lg p-6 transform transition-transform duration-300 will-change-transform hover:scale-[1.03]">
                    <div className="mb-4 flex justify-center">
                      <img src={value.icon} alt={`${value.title} icon`} className="w-10 h-10 object-contain" />
                    </div>
                    <h3 
                      className="mb-3 text-center"
                      style={{ 
                        fontFamily: 'Belleza, serif', 
                        fontWeight: 400, 
                        fontSize: '20px', 
                        lineHeight: '120%', 
                        color: '#272525'
                      }}
                    >
                      {value.title}
                    </h3>
                    <div className="mb-3 flex justify-center">
                      <img 
                        src="/Rectangle 31.png" 
                        alt="Decorative line"
                        className="w-48 h-auto object-contain"
                      />
                    </div>
                    <p 
                      className="text-left"
                      style={{ 
                        fontFamily: 'Poppins, sans-serif', 
                        fontWeight: 400, 
                        fontSize: '12px', 
                        lineHeight: '140%', 
                        color: '#272525'
                      }}
                    >
                      {value.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Values Section - Desktop */}
      <section className="relative padding-responsive hidden md:block overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: "url('/Rectangle 18.png')" }}
        />
        <div className="relative z-10">
          <div className="container-responsive">
            <div className="text-center mb-12 sm:mb-16">
              <p 
                className="uppercase tracking-widest text-responsive-sm text-dark mb-3 sm:mb-4"
                style={{ fontFamily: 'Poppins, sans-serif' }}
              >
                OUR VALUES
              </p>
              <h2 
                className="subheading-responsive text-dark leading-tight"
                style={{ fontFamily: 'Belleza, serif' }}
              >
                What We Stand For Every Day
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mx-8 lg:mx-16">
              {values.map((value, index) => (
                <div 
                  key={index} 
                  className={`relative flex justify-center ${index % 2 === 0 ? 'md:-translate-y-8' : 'md:translate-y-8'}`}
                >
                  <div className="absolute w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center z-20 -translate-x-1/2"
                    style={{
                      left: value.positions.desktop.left,
                      top: value.positions.desktop.top
                    }}>
                    <span 
                      className="text-dark text-lg font-semibold"
                      style={{ fontFamily: 'Poppins, sans-serif' }}
                    >
                      {value.number}
                    </span>
                  </div>
                  
                  <div 
                    className="relative w-full h-80 overflow-hidden transform transition-transform duration-300 will-change-transform hover:scale-[1.06]"
                    style={{
                      backgroundImage: index % 2 === 0 ? "url('/Union.png')" : "url('/Union (1).png')",
                      backgroundSize: 'contain',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center'
                    }}
                  >
                    <div className="relative z-10 h-full flex flex-col justify-center items-center px-4 py-8">
                      <div className="mb-4">
                        <img src={value.icon} alt={`${value.title} icon`} className="w-10 h-10 object-contain" />
                      </div>
                      <h3 
                        className="mb-4 text-left"
                        style={{ 
                          fontFamily: 'Belleza, serif', 
                          fontWeight: 400, 
                          fontSize: '20px', 
                          lineHeight: '120%', 
                          color: '#272525' 
                        }}
                      >
                        {value.title}
                      </h3>
                      <div className="mb-2">
                        <img 
                          src="/Rectangle 31.png" 
                          alt="Decorative line"
                          className="w-48 h-auto object-contain"
                        />
                      </div>
                      <p 
                        className="text-left px-2"
                        style={{ 
                          fontFamily: 'Poppins, sans-serif', 
                          fontWeight: 400, 
                          fontSize: '12px', 
                          lineHeight: '140%', 
                          color: '#272525' 
                        }}
                      >
                        {value.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>


      {/* Local CSS overrides for Navbar (About page only) */}
      <style jsx>{`
        /* Keep navbar elements above ribbons */
        #about-nav nav { position: relative; z-index: 50; }
        #about-nav img[alt="HIK"] { 
          margin-top: 0.5rem !important; 
          position: relative; 
          z-index: 50; 
        }

        @media (min-width: 768px) {
          #about-nav img[alt="HIK"] { 
            margin-top: 1rem !important; 
          }
        }

        /* Default (top of page): black navbar links/buttons */
        #about-nav .md\\:flex a,
        #about-nav .md\\:flex button {
          margin-top: 0.5rem !important;
          color: #272525 !important;
          font-family: Belleza, serif !important;
          font-weight: 400 !important;
          font-size: 20px !important;
          line-height: 100% !important;
        }

        /* Button alignment tweak to match left items */
        #about-nav .md\\:flex button {
          padding-top: 0.375rem !important;
          padding-bottom: 0.375rem !important;
          position: relative; 
          top: -4px;
        }

        /* When scrolled: turn navbar text white */
        #about-nav.scrolled .md\\:flex a,
        #about-nav.scrolled .md\\:flex button {
          color: #ffffff !important;
        }
      `}</style>
    </div>  
  );
};

export default AboutPage;